<template>
  <div>
    <detailsInternalRequest
      ref="details"
      v-bind="bindDetail"
    ></detailsInternalRequest>
    <el-row type="flex" justify="end">
      <el-col :span="4">
        <el-select
          size="mini"
          placeholder="Cliente"
          v-model="CustomersFilter"
          filterable
          clearable
          @change="handleFilters"
        >
          <el-option
            v-for="(item, index) in list_customersSelect"
            :key="index"
            :value="item.ClientCode"
            :label="item.Name"
          />
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <rabbey-table-3
          :border="true"
          :stripe="true"
          :loading="loading"
          :data="report"
          :columns="mapColumns"
          :summary-method="getSummaries"
          show-summary
        />
      </el-col>
    </el-row>
    <!-- <rabbey-base-drawer
        :title="title"
        :drawer.sync="drawer"
        size="85%"
        :before-close="CloseDetails"
      >
        <el-row>
          <div>
            <DetailChart ref="detailChart" :DetailParams="DetailData" />
          </div>
          <el-col>
            <rabbey-table-3
              :border="true"
              :stripe="true"
              :actions="actions"
              @rtable-push-action="handlePushAction"
              :loading="loadingDetail"
              :data="requests"
              :columns="columnsDetails"
            />
          </el-col>
        </el-row>
      </rabbey-base-drawer> -->
  </div>
</template>

<script>
//   import { MONTHS_LIST } from "@/const";
import { formatArrayToElSelect } from "@/utils";
import { mapGetters } from "vuex";

export default {
  name: "TerminalContractRequest",
  created() {
    this.fetchReport();
  },
  data() {
    return {
      loading: false,
      loadingDetail: false,
      selectedEmployee: this.currentUserId,
      selectedDirection: 0,
      // actions: [
      //   {
      //     icon: "el-icon-view",
      //     label: "Ver Detalle",
      //     command: "details"
      //   }
      // ],
      bindDetail: {
        comments: [],
        descripcionLaga: "",
        descripcionCorta: ""
      },
      columns: [
        {
          prop: "Clientcode",
          label: "Codigo de cliente",
          minWidth: 160,
          sortable: true,
          fix: true
        },
        {
          prop: "Nombre",
          label: "Nombre",
          minWidth: 200,
          sortable: true,
          fix: true
        },
        {
          prop: "Contrato",
          label: "Contrato",
          minWidth: 200,
          sortable: true,
          fix: true
        },
        {
          prop: "service",
          label: "Servicio",
          minWidth: 200,
          sortable: true,
          fix: true
        },
        {
          prop: "cantidadServicios",
          label: "Cantidad de Servicios",
          minWidth: 200,
          sortable: true,
          fix: true
        },
        {
          prop: "precio",
          label: "Precios de Servicios",
          minWidth: 200,
          sortable: true,
          fix: true
        },
        {
          prop: "precioTotal",
          label: "Precio Total",
          minWidth: 150,
          sortable: true,
          fix: true
        }
      ],
      // columnsDetails: [
      //   {
      //     prop: "Id",
      //     label: "NO",
      //     width: 90,
      //     sortable: true
      //     //formatter: SLAClolorStatus
      //   },
      //   {
      //     prop: "TipoSolicitud",
      //     label: "Tipo",
      //     minWidth: 255,
      //     sortable: true
      //   },
      //   {
      //     prop: "corta",
      //     label: "Descripcion",
      //     minWidth: 400,
      //     sortable: true
      //   },
      //   {
      //     prop: "Valoracion",
      //     label: "Valoracion",
      //     minWidth: 150,
      //     align: "center",
      //     formatter: GetRate,
      //     sortable: true
      //   },
      //   {
      //     prop: "ComentarioValoracion",
      //     label: "Comentario",
      //     minWidth: 250,
      //     sortable: true
      //   },
      //   {
      //     prop: "SlaDaysToResponse",
      //     label: "SLA",
      //     minWidth: 75,
      //     align: "center",
      //     sortable: true
      //   },
      //   {
      //     prop: "DiasRetrasadosSla",
      //     label: "Dias Retrasada",
      //     minWidth: 150,
      //     align: "center",
      //     formatter: SLAClolorStatus,
      //     sortable: true
      //   },
      //   {
      //     prop: "CreatedAt",
      //     label: "Creado",
      //     formatter: DatetimeFormatter,
      //     minWidth: 130,
      //     sortable: true
      //   },
      //   {
      //     prop: "ClosedAt",
      //     label: "Cerrado",
      //     formatter: DatetimeFormatter,
      //     minWidth: 130,
      //     sortable: true
      //   }
      // ],
      report: [],
      year: new Date().getFullYear(),
      request_type: null,
      title: "",
      drawer: false,
      selectedTechnician: "",
      requests: [],
      technicians: [],
      techniciansLoading: false,
      //requestColumns: requestColumns,
      createdOrClosed: true,
      serviceRequestType: null,
      DetailData: {
        Month: 0,
        chartData: []
      }
    };
  },
  computed: {
    ...mapGetters({
      list_customersSelect: "customers/list_to_select",
      loading_customers: "customers/isLoading"
    }),
    mapColumns() {
      let columns = this.columns;
      // for (let i = 0; i < 12; i++) {
      //   const month = MONTHS_LIST[i];
      //   columns.push({
      //     prop: month,
      //     label: this.$t(`months.${month}`),
      //     name: this.$t(`months.${month}`),
      //     attrs: {
      //       openSelect: this.openSelect,
      //       getType: this.getType,
      //       month: i + 1
      //     },
      //     formatter: HyperLinkSeller
      //   });
      // }

      // columns.push({
      //   prop: "Totals",
      //   label: "Total",
      //   name: "Total",
      //   attrs: {
      //     isTotal: true,
      //     openSelect: this.openSelect,
      //     month: 0
      //   },
      //   formatter: HyperLinkSeller
      // });
      return columns;
    }
  },
  methods: {
    formatArrayToElSelect,
    fetchReport() {
      this.loading = true;

      this.$http
        .get("/api/contracts/GetContractFromNCF", {
          // params: {
          //   company: this.currentCompany,
          //   year: this.year,
          //   requestType: this.request_type,
          //   close: this.createdOrClosed,
          //   status: this.serviceRequestType,
          //   responsableId:
          //     this.selectedEmployee == 0 ? null : this.selectedEmployee,
          //   direction:
          //     this.selectedDirection == 0 ? null : this.selectedDirection
          // }
        })
        .then(({ data }) => {
          this.report = data;
        })
        .catch((error) => console.error(error))
        .finally(() => (this.loading = false));
    },
    handlePushAction(option) {
      if (option.command == "details") {
        this.bindDetail = {
          comments: [],
          descripcionLaga: option.row.Descripcion,
          descripcionCorta: option.row.corta
        };

        // if (option.row != null && option.row.Activities != null) {
        //   const c = option.row.Activities.filter(a => (a.Type = 1));
        //   this.bindDetail.comments = JSON.parse(JSON.stringify(c));
        // }
        this.$refs.details.drawer = true;
      }
    },
    // openSelect(props) {
    //   this.loadingDetail = true;
    //   this.title = `Solicitudes asignadas a ${props.row.ResponsableName}`;
    //   this.drawer = true;
    //   this.DetailData = {
    //     Month: props.month
    //   };
    //   this.$http
    //     .get("/api/InternalServiceRequest/GetInternalServiceReportDetails", {
    //       timeout: 3000 * 6 * 1000,
    //       params: {
    //         company: this.currentCompany,
    //         year: this.year,
    //         tecnicoID: props.row.ResponsableId,
    //         month: props.month,
    //         requestType: this.request_type,
    //         close: this.createdOrClosed,
    //         status: this.serviceRequestType
    //       }
    //     })
    //     .then(({ data }) => {
    //       this.requests = data.serviceList;
    //       this.DetailData.chartData = data.serviceChart;
    //       this.$refs.detailChart.getChartData();
    //     })
    //     .finally(() => (this.loadingDetail = false));
    // },
    // CloseDetails() {
    //   this.drawer = false;
    //   this.$refs.detailChart.bar.series[0].data = [];
    //   this.$refs.detailChart.loading = true;
    // },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "Totales :";
        }
      });

      return sums;
    }
  }
};
</script>

<style>
.el-table .warning-row {
  /* background: #ff6666; */
  color: #ff6666;
}
</style>
